import axios from 'axios';
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
  timeout: 30000, 
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true, 
});

apiClient.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let failedRequestsQueue = [];

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        deslogarUsuario();
        return new Promise((resolve, reject) => {
          failedRequestsQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            return apiClient(originalRequest);
          })
          .catch(err => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const accessTokenStored  = localStorage.getItem('accessToken');
        const refreshTokenStored  = localStorage.getItem('refreshToken');

        if(!accessTokenStored || !refreshTokenStored){
          deslogarUsuario();
        }
        const response = await apiClient.post('/auth/refresh-token', {
          accessToken: accessTokenStored,
          refreshToken: refreshTokenStored 
        });

        const { accessToken, refreshToken } = response.data;

        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);

        originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;

        failedRequestsQueue.forEach(({ resolve }) => resolve(accessToken));
        failedRequestsQueue = [];

        return apiClient(originalRequest);
      } catch (err) {
          failedRequestsQueue.forEach(({ reject }) => reject(err));
          failedRequestsQueue = [];
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login';
      }finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

const deslogarUsuario = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    window.location.href = '/login';
};

export default apiClient;
